<template>
    <div class="mvt-searchfilter" ref="searchFilter" :class="{'mode-sale': isSale, 'mode-sold': isSold, 'mode-rent': isRent, 'mode-focus': isFocusMode, 'wide': wide}" :comp="$options.name" data-role="overlay">
        <div class="mvt-searchfilter-header flex">
            <button type="button" @click="close"><i class="icon-times f4"></i></button>
            <button class="btn small primary" type="button" @click="saveSearch">
                Save search
            </button>
        </div>
        <div class="mvt-searchfilter-body grid xs-grid-cols-1 top gap-3">
            <button type="button" class="mvt-searchfilter-close" @click="close"><i class="icon-times"></i></button>
            <ul class="tab tab-bookmark center small">
                <li><button type="button" @click="switchIndex(0)" :class="isSale ? 'active': ''">For Sale</button></li>
                <li><button type="button" @click="switchIndex(1)" :class="isRent ? 'active': ''">For Rent</button></li>
                <li><button type="button" @click="switchIndex(2)" :class="isSold ? 'active': ''">Sold</button></li>
            </ul>
            <template v-for="item in searchFilterData">
                <div :id="item.id" class="grid xs-grid-cols-1 gap-1 mvt-searchfilter-item" :class="{'focused': focusIds.includes(item.id), 'grouped': focusIds.length>1}">
                    <div class="sub f7 text-gray" v-if="item.subTitle">{{item.subTitle}}</div>
                    <div class="filter-title">
                        <span class="text-bold">{{ getTitle(item) }}</span>
                    </div>
                    <component
                        class="small toggle"
                        :order="item.order"
                        :is="item.type"
                        :label="item.label"
                        :data="item.data"
                        :disabled="item.disabled"
                        :theme="item.theme"
                        v-model="filterModel[item.model]"
                        :options="item.options"
                    />
                </div>
            </template>
            <slot></slot>
        </div>
        <div class="mvt-searchfilter-footer grid xs-grid-cols-2">
            <button class="btn secondary small" type="button" @click="resetFilter">Reset</button>
            <button class="btn small primary" type="button" @click="applyFilter">
                Apply <span v-if="resultCount > 0">({{resultCount}})</span>
            </button>
        </div>
    </div>
    <div class="mvt-searchfilter-overlay" @click="close"></div>
</template>
<script src="./mvt-searchfilter.js"></script>
<style lang="scss">
@use "./mvt-searchfilter.scss" as *;
</style>